module.exports = __webpack_public_path__ + "media/newstyle/images/boleto-f50f8784afb4ea2f10e1ae855ad3e680.svg";